<template>
	<el-row :gutter="10" class="stat-numbers common" style="font-family: Bebas Neue;">
		<template v-if="$store.state.user.userInfo.bureau_admin.subject_id === 0">
			<el-col :span="6"
				><router-link :to="{ name: 'schoolManagement' }">
					<div class="number-block number-block-class">
						<div class="caption">
							<span
								>管辖学校<svg class="icon" aria-hidden="true">
									<use xlink:href="#icon-iconoutlinearrowenter"></use></svg
							></span>
						</div>
						<p>{{ mgnSchoolNumber }}<span>所</span></p>
					</div></router-link
				>
			</el-col>
			<el-col :span="6"
				><router-link :to="{ name: 'classgradeManagement' }">
					<div class="number-block number-block-class">
						<div class="caption">
							<span>管辖班级</span
							><svg class="icon" aria-hidden="true">
								<use xlink:href="#icon-iconoutlinearrowenter"></use>
							</svg>
						</div>
						<p>{{ mgnClassNumber }}<span>个</span></p>
					</div></router-link
				>
			</el-col>
			<el-col :span="6"
				><router-link :to="{ name: 'teacherManagement' }">
					<div class="number-block number-block-student">
						<div class="caption">
							<span>管辖老师</span
							><svg class="icon" aria-hidden="true">
								<use xlink:href="#icon-iconoutlinearrowenter"></use>
							</svg>
						</div>
						<p>{{ mgnTeacherNumber }}<span>名</span></p>
					</div></router-link
				>
			</el-col>
		</template>

		<template v-else>
			<el-col :span="6"
				><router-link :to="{ name: 'declarationList', params: { sbid: subject_id } }">
					<div class="number-block number-block-declaration">
						<div class="caption">
							<span>待处理申报</span
							><svg class="icon" aria-hidden="true">
								<use xlink:href="#icon-iconoutlinearrowenter"></use>
							</svg>
						</div>
						<p>{{ pendingDeclarationNumber }}<span>个</span></p>
					</div></router-link
				>
			</el-col>
		</template>
	</el-row>
</template>

<script>
export default {
	data() {
		return {
			subject_id: null,
			mgnClassNumber: '-',
			mgnTeacherNumber: '-',
			mgnSchoolNumber: '-',
			pendingDeclarationNumber: '-'
		}
	},
	created() {
		this.subject_id = this.$store.state.user.userInfo.bureau_admin.subject_id ?? null

		// 数字
		this.$api.bureau_admin.show(this.$store.state.user.userInfo.id).then(res => {
			this.mgnSchoolNumber = res.schools_count
			this.mgnClassNumber = res.class_grades_count
			this.mgnTeacherNumber = res.teachers_count
		})

		this.$api.user
			.listDeclaration(0, {
				pov: 1,
				filterBy: {
					state: this.$api.declaration.state.IN_PROGRESS.value
				},
				paginate: {
					size: 1
				}
			})
			.then(res => {
				this.pendingDeclarationNumber = res.meta.total
			})
	}
}
</script>

<style></style>
